<template>
    <div class="input-border-radius">
        <slot name="prepend"></slot>
        <btn-border-radius v-for="(preset, index) in presets" :key="`radius-${index}`" v-model="currentBorderRadius" :preset="preset"/>
        <b-input v-if="currentBorderRadius !== `var(--border-radius)`" class="custom-value" v-model="currentBorderRadius"/>
    </div>
</template>

<script>
import BtnBorderRadius from "@/components/editor/properties/inputs/btn-border-radius.vue";
import EInput from "../../../../../vue-components/components/e-input.vue";

// input-border-radius #hot-reload-debug
export default {
    name: `input-border-radius`,
    components: {EInput, BtnBorderRadius},
    props: {
        value: {type: String},
        more: {type: Boolean},
        noTheme: {type: Boolean},
        noCircle: {type: Boolean}
    },
    computed: {
        presets() {
            let presets = [];
            if (!this.noTheme) {
                presets.push({title: `Theme|Thème` , value: `var(--border-radius)`});
            }
            presets.push({title: null, value: `0`});
            if (this.more) {
                presets.push({title: null, value: `3px`});
            }
            presets.push({title: null, value: `5px`});
            presets.push({title: null, value: `8px`});
            presets.push({title: null, value: `15px`});
            presets.push({title: null, value: `100px`});
            if (!this.noCircle) {
                presets.push({title: null, value: `50%`});
            }
            return presets;
        },
        currentBorderRadius: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit(`input`, value);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.input-border-radius {
    display: flex;
}

.custom-value {
    max-width: 90px;
    min-width: 0;
    text-align: right;
}
</style>
